import { ContainerModule } from 'inversify';
import { QuizPlayerStateMachine } from './state-machine'

export const quizPlayerDomainModule = new ContainerModule((bind) => {
  bind(QuizPlayerStateMachine).toSelf()
});
